import { Injectable } from "@angular/core";
import { RolePermissionGuard } from "./role.permission.guard";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../services/api/authentication.service";

@Injectable()
export class ManageUsersPermissionGuard extends RolePermissionGuard {
  constructor(
    override applicationUserService: AuthenticationService,
    override router: Router
  ) {
    super(applicationUserService, router, ["Administrator", "InternalSales"], "/portal/home");
  }
}
